<main id="login-page">
    <div class="container main-panel">
        <div class="row" [ngStyle]="{display : getDisplaySuccess()}">
            <div class="col-sm-12 col-md-12 margin-bottom-30">
                <h4>We have sent you a confirmation email and it should arrive in your mailbox in a few minutes. Please
                    check your email and click on the link in order to complete your subscription to Lawshelf. If your
                    confirmation email has not arrived after a few minutes, check your spam folder.</h4>
            </div>
        </div>

        <div class="row" [ngStyle]="{display : getDisplayLogin()}">
            <div class="col-lg-12 col-md-12 col-sm-12 signup-col">
                <div class="signup-wrap" id="registerArea">
                    <form class="registerFormCl" id="registerForm" (ngSubmit)="onSubmit(registerForm)"
                        #registerForm="ngForm">
                        <alert></alert><br>
                        <h3>Register</h3>
                        <div class="registerDetails">
                            <strong>You must be registered in order to take exams and earn a digital badge credential.
                            </strong>
                            <P></P>
                        </div>
                        <hr>
                        <div class="form-row margin-top-10">
                            <div class="form-group col-md-6 col-sm-6">
                                <input class="form-control" ngModel required id="FirstName" name="FirstName"
                                    placeholder="first name" type="text" value="">
                            </div>
                            <div class="form-group col-md-6 col-sm-6">
                                <input class="form-control" ngModel required id="LastName" name="LastName"
                                    placeholder="last name" type="text" value="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12 col-sm-12">
                                <input class="form-control" ngModel required email id="Email" name="Email"
                                    placeholder="email address" type="email" value="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 col-sm-6">
                                <input class="form-control" ngModel required id="Password" name="Password"
                                    placeholder="password" type="Password" value="">
                            </div>
                            <div class="form-group col-md-6 col-sm-6">
                                <input class="form-control" ngModel required id="ConfirmPassword" name="ConfirmPassword"
                                    placeholder="confirm password" type="Password" value="">
                            </div>
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="text-center">
                                    <h4>LawShelf Terms of Service</h4>
                                </div>
                            </div>
                        </div>
                        <div class="myframe margin-bottom-5">
                            <app-terms-of-service></app-terms-of-service>
                        </div>

                        <div class="form-row margin-bottom-20">
                            <div class="form-group col-md-12">
                                <input checked="checked" ngModel class="form-control, form-check-input" id="AcceptTerms"
                                    name="AcceptTerms" type="checkbox" value="true">
                                <!-- <input name="acceptTerms" type="hidden" value="false"> -->
                                <label style="margin-left: 20px" checked="checked" class="form-check-label blacktext"
                                    for="acceptTerms">I agree to the terms of service</label>
                                <small>
                                    <span class="field-validation-valid" data-valmsg-for="acceptTerms"
                                        data-valmsg-replace="true"></span>
                                </small>
                            </div>
                        </div>

                        <button [disabled]="!registerForm.valid" class="btn btn-block" type="submit"
                            id="registerBtn">Subscribe</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</main>